import { ESRI } from '../../constants/mapProviders';
import { createMap } from '../../providers/esri/createMap';
import { configureEsriMaps } from '../../utils/utils';

/**
 * Initializes the map for a given map rovider and API key and returns the Map object with the map provider for use with the map interface
 * @param {String} mapProvider - map provider to use
 * @param {String} apiKey - API key for the map provider
 * @param {Object} mapOptions - configs to pass to the map provider
 * @param {HTMLElement} mapOptions.mapContainer - The reference to the DOM
 * element to render the map
 * @param {Array|Object} mapOptions.center - {lat: yy, lng}} or [lng, lat] for
 * the map provider to center
 * on
 */
export const initializeMap = ({
  mapProvider,
  apiKey,
  mapOptions,
  viewOptions,
}) => {
  // Return the mapProvider with the mapObject
  switch (mapProvider) {
    case ESRI: {
      configureEsriMaps(apiKey);
      return createMap({
        mapContainer: mapOptions.mapContainer,
        esriMapOptions: mapOptions,
        esriViewOptions: {
          ...viewOptions,
          center: mapOptions.center,
          shapes: mapOptions.shapes,
        },
      }).then(res => {
        return {
          mapProvider,
          mapInstance: res,
        };
      });
    }
    default:
      // TODO: for google maps, this may have to return a promise with the
      // object or change the function to include callback({mapProvider, mapInstance})
      return {
        mapProvider,
        mapInstance: {},
      };
  }
};

export default initializeMap;
